import axios from "axios";
import Vue from "vue";
export default {
    bind(el) {
      el.__imageObserver__ = new MutationObserver(() => {
        scanImages(el);
      });
    },
    inserted(el) {
      scanImages(el);
      el.__imageObserver__.observe(el, { 
        childList: true, 
        subtree: true 
      });
    },
    unbind(el) {
      el.__imageObserver__?.disconnect();
    }
  };
  
  function scanImages(el) {
    Vue.nextTick(() => {
      setTimeout(() => {
        const roots = [el, ...findEditorContainers(el)];
        roots.forEach(root => {
          root.querySelectorAll('img:not([data-processed])').forEach(img => {
            img.src = normalizeImageSrc(img.getAttribute('src'));
            img.dataset.processed = 'true';
          });
        });
      }, 100);
    });
  }
  
  function findEditorContainers(el) {
    return Array.from(el.querySelectorAll([
      '.ql-editor',       // Quill
      '.tox-edit-area',    // TinyMCE
      '.ce-paragraph'      // Editor.js
    ].join(',')));
  }
  
  function normalizeImageSrc(src) {
    const CDN_DOMAIN = axios.defaults.baseURL
    if (!src) return '';
    return src.startsWith('http') ? src : `${CDN_DOMAIN}${src}`;
  }